import React from 'react';
import { useTranslation } from 'react-i18next';
import { SortFilter } from '../SortFilter/SortFilter';
import { ClassifySubMenu } from '../ClassifySubMenu/ClassifySubMenu';
import '../SortBy/SortBy.scss';

export interface ClassifySortByProps {
  selectedKey?: string;
}

export const ClassifySortBy: React.FC<ClassifySortByProps> = ({ selectedKey }) => {
  const { t } = useTranslation();

  return (
    <div className="sort-by">
      <div className="sort-by__container">
        <div className="sort-by__main-row">
          <span className="sort-by__label">{t('sortBy.label')}</span>
          <SortFilter storageKeyBase="CLASSIFY_MFE_PROPS_SORT_BY" selectedKey={selectedKey} eventName="mfe-classify-sort-by-change" />
        </div>
        <div className="sort-by__submenu-row">
          <ClassifySubMenu />
        </div>
      </div>
    </div>
  );
};